import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { userToken } = useSelector((state) => state.user);

  return (
    <React.Fragment>
      {userToken !== ""
        ? children
        : <Navigate to="/login" />
      }
    </React.Fragment>
  );
}

export default ProtectedRoute